import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import './Topbar.css';
import {FaBell, FaTools, FaDatabase, FaMapMarkedAlt, FaBars, FaTimes} from 'react-icons/fa';

function Topbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('');


    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = 'visible';
        }
    }, [isOpen]);


    const toggleSidebar = () => setIsOpen(!isOpen);

    const handleLinkClick = (page) => {
        setActiveLink(page);
        setIsOpen(false);  // Optionally close the sidebar on link click
    }

    return (
        <div className={`topbar-container ${isOpen ? 'topbar-expanded' : 'topbar-collapsed'}`}>

            {isOpen ? (
                <button onClick={toggleSidebar} className="topbar-button-close">
                    <FaTimes/> დახურვა
                </button>
            ) : (
                <button onClick={toggleSidebar} className="topbar-button">
                    <FaBars/> ნავიგაცია
                </button>
            )}

            {isOpen && (
                <div className="topbar-links">
                    <Link  to="/dashboard/home" className={`topbar-link ${activeLink === 'home' ? 'active' : ''}`} onClick={() => handleLinkClick('home')}><FaBell/> შეტყობინებები</Link>
                    <Link  to="/dashboard/services" className={`topbar-link ${activeLink === 'services' ? 'active' : ''}`} onClick={() => handleLinkClick('services')}><FaTools/> სერვისები</Link>
                    <Link  to="/dashboard/registery" className={`topbar-link ${activeLink === 'registery' ? 'active' : ''}`} onClick={() => handleLinkClick('registery')}><FaDatabase/> უწყებრივი რეესტრი</Link>
                    <Link  to="/dashboard/map" className={`topbar-link ${activeLink === 'map' ? 'active' : ''}`} onClick={() => handleLinkClick('map')}><FaMapMarkedAlt/> ინტერატრიული რუკა</Link>
                </div>
            )}
        </div>
    );
}

export default Topbar;
